import React from "react";
import { ChevronRight } from "lucide-react";

const LEVEL_DOT = {
  critical: "bg-red-500",
  high:     "bg-orange-400",
  medium:   "bg-amber-400",
  healthy:  "bg-emerald-500",
};

const LEVEL_TEXT = {
  critical: "text-slate-800 dark:text-slate-100",
  high:     "text-slate-800 dark:text-slate-100",
  medium:   "text-slate-700 dark:text-slate-200",
  healthy:  "text-slate-600 dark:text-slate-300",
};

export default function PriorityCard({ priority, compact = false, onClick }) {
  const dotClass  = LEVEL_DOT[priority.level]  ?? "bg-slate-300";
  const textClass = LEVEL_TEXT[priority.level] ?? "text-slate-700 dark:text-slate-200";
  const py        = compact ? "py-2" : "py-2.5";

  const inner = (
    <>
      <div className={`h-2 w-2 rounded-full shrink-0 ${dotClass}`} />
      <p className={`flex-1 text-[13px] font-medium ${textClass} leading-snug`}>
        {priority.message}
      </p>
      {onClick && (
        <ChevronRight size={14} className="text-slate-300 dark:text-slate-600 shrink-0" />
      )}
    </>
  );

  if (onClick) {
    return (
      <button
        onClick={onClick}
        className={`w-full flex items-center gap-3 ${py} text-left transition-all duration-200 active:opacity-70`}
      >
        {inner}
      </button>
    );
  }

  return (
    <div className={`flex items-center gap-3 ${py}`}>
      {inner}
    </div>
  );
}
